import { format, parse } from 'date-fns';

import { fileItemTypes } from '@constants/fileItemTypes';
import { CATEGORY_CHOICES } from '@constants/vatReturns';
import { getFileType } from '@containers/UploadDataList/helpers/getFileType';

/**
 * File shape
 * @typedef {Object} File
 * @param {string} id - unique identifier
 * @param {string} name - file name
 * @param {string} [date] - game changer file date
 * @param {string} [savedFilingPeriod] - saved filing period unique identifier
 * @param {string} [uploadedBy] - unique identifies user who uploaded
 * @param {string} [category] - document category
 * @param {string} [extension] - document extension
 * @param {string} [sizeDisplay] - document size
 * @param {Date} [dateCreated] - document creation date
 * @param {Date} [dateUploaded] - online spreadsheet file date uploaded
 * @param {Date} [dateModified] - online spreadsheet file date modified
 * @param {string} [standardTemplate] - standard template unique identifier
 * @param {bool} sourceHasBeenProcessed - has the source file been processed?
 */

/**
 * Builds a files list with game changer, online spreadsheet or normal uploaded files.
 * @param {Array<File>} [files=[]] - optional list of game changer files
 * @param {string} [type] - optional list of online spreadsheets
 * @returns {Array<File&{type: string, fileType: string}>}
 */

export const fileListModel = (files = [], type) =>
  files.map(file => {
    let fileType = getFileType(file.extension);

    if (type === CATEGORY_CHOICES.GAME_CHANGER_OUTPUT) fileType = fileItemTypes.IMPORT;
    if (type === CATEGORY_CHOICES.ONLINE_SPREADSHEET) fileType = fileItemTypes.ONLINE_SPREADSHEET;

    return {
      ...file,
      type,
      fileType,
      name:
        type === CATEGORY_CHOICES.GAME_CHANGER_OUTPUT
          ? `${file.name} ${format(parse(file.date, 'MM/yyyy', new Date()), 'MMMM yyyy')}`
          : `${file.name}${file.extension ? `.${file.extension}` : ''}`,
    };
  });
